export default __webpack_public_path__ + "static/media/View.9aaf7d85.md";